// What happened at my card table (owner 2026-10-29: "poinformuj, że dany gracz wyszedł i został zastąpiony botem"):
// a short notice under the top bar ("Anna: no connection, a bot plays for now"), and while the bot plays for me (my
// turns ran out several times) a bar with "I'm back".
import { useEffect, useState } from 'react';
import { t } from '../i18n';
import { mpStore, useMultiplayerState } from '../multiplayer/store';
import { WithFlag } from './PlayerName';

const SHOW_MS = 6000;

export function CardNotice() {
  const mp = useMultiplayerState();
  // each notice (its number n) shows SHOW_MS, then counts as seen
  const [seen, setSeen] = useState<number | null>(null);
  const n = mp.cardNotice?.n ?? null;
  useEffect(() => {
    if (n === null) return undefined;
    const id = window.setTimeout(() => setSeen(n), SHOW_MS);
    return () => clearTimeout(id);
  }, [n]);
  if (!mp.cards) return null;
  if (mp.asleep) {
    return (
      <div className="mp_searching mp_notice mp_asleep" role="alert">
        <span className="mp_searching_text">
          <b>{t('lobby.asleep')}</b>
        </span>
        <button type="button" onClick={() => mpStore().back()}>{t('lobby.back')}</button>
      </div>
    );
  }
  if (mp.watching) {
    return (
      <div className="mp_searching mp_notice" role="status">
        <span className="mp_searching_text">{t('lobby.watching')}</span>
      </div>
    );
  }
  if (n === null || seen === n || !mp.cardNotice) return null;
  return (
    <div className="mp_searching mp_notice" role="status">
      <span className="mp_searching_text">
        <WithFlag text={mp.cardNotice.text} name={mp.cardNotice.name} flag={mp.cardNotice.flag} />
      </span>
    </div>
  );
}
